import classes from './LoadingCircle.module.css';

export default function LoadingCircle() {
  return (
    <svg className={classes.svg} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle className={classes.circle} cx="50" cy="50" r="45" />
    </svg>
  );
}
